import StoreModuleService from '../StoreModuleService';
import { initialState } from './state';
import Vue from 'vue';

// mutations declarations
export const SET_VALUE_FOR_PARAM_KEY = 'SET_VALUE_FOR_PARAM_KEY';
export const CLEAR_STATE_FOR_PARAM_KEY = 'CLEAR_STATE_FOR_PARAM_KEY';

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[SET_VALUE_FOR_PARAM_KEY](state, payload) {
		const { paramKey, key, value } = payload;
		if (!(paramKey in state.data)) {
			Vue.set(state.data, paramKey, {});
		}
		if (typeof value === 'object' || state.data[paramKey][key] !== value) {
			// PERFORMANCE_OPTIMIZATION: Add a check for primitive types.
			// We don't check Objects and arrays as it might be expensive to check.
			Vue.set(state.data[paramKey], key, value);
		}
	},
	[CLEAR_STATE_FOR_PARAM_KEY](state, payload) {
		const { paramKey } = payload;
		Vue.delete(state.data, paramKey);
	},
};

export default mutations;
